import React, { useState, useEffect } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout, Form, Button, Spin, notification, message, PageHeader, Space } from 'antd';
import {
  GET_CONTRACT_DATA_FORM,
  CONTRACT_FORM_DATA,
  ADMIN_UPDATE_CONTRACT_FORM_DATA,
  CONTRACT_IS_CREATED,
  GET_CONTRACT_PDF,
  GET_PREVIEW_PDF
} from '../../state/lease_contract/types';
import { RESOURCE } from '../../config/constants/alerts';
import alertError from '../../components/alerts/AlertErrorForm';
import ObjectionMessage from '../../components/ObjectionMsg';
import { OBJECTION_MSG_ADMIN_KEY } from '../../config/constants/forms';
import { CREATE_CONTRACT_STATUS } from '../../config/constants/states';
import PreviewModal from '../../components/formPreview/PreviewModal';
import PropTypes from 'prop-types';
import ShowPdf from '../../components/pdf/ShowPdf';
import CreateContractHeader from '../../components/create_contract/header/index';
import SignersStep from '../../components/contract/SignersStep';
import PropertyStep from '../../components/contract/PropertyStep';
import AccountStep from '../../components/contract/AccountStep';
import Schema from '../../classes/index';

const { Content, Header } = Layout;

const EditContract = ({
  getContractDataForm,
  contractFormData,
  updateForm,
  sendContract,
  isCreated,
  isLoaded,
  resetStatus,
  images,
  contractPdf,
  getPDF,
  getPreview,
}) => {

  const [form] = Form.useForm();
  const { params } = useParams();
  const [current, setCurrent] = useState(0);
  const [loaderSpinning, setLoaderSpinning] = useState(true);
  const [objMsg, setObjMsg] = useState({});
  const history = useHistory();
  const { pathname } = useLocation();
  const [siderVisible, setSiderVisible] = useState(true);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    if (!contractFormData.contractId) getContractDataForm(params);
    if (contractPdf === '') { getPDF(params); }
  }, []);

  useEffect(() => {
    if (contractFormData.editForm) form.setFieldsValue(contractFormData);
  }, [contractFormData]);

  useEffect(() => {
    if (isCreated === CREATE_CONTRACT_STATUS.SUCCESS) {
      setLoaderSpinning(false);
      resetStatus();
      message.success('Contrato fue editado', 10);
      notification.close(OBJECTION_MSG_ADMIN_KEY);
      history.push(`/contracts/contract_detail/${params}`);
    };
    if (isCreated === CREATE_CONTRACT_STATUS.FAIL) {
      setLoaderSpinning(false);
      resetStatus();
      message.error('Ha ocurrido un error', 10);
      notification.close(OBJECTION_MSG_ADMIN_KEY);
    };
  }, [isCreated]);

  useEffect(() => {
    setLoaderSpinning(false);
    if (contractFormData.objectionMessage) {
      setObjMsg(contractFormData.objectionMessage);
    }
  }, [isLoaded]);

  useEffect(() => {
    if (Object.keys(objMsg).length !== 0) {
      ObjectionMessage(OBJECTION_MSG_ADMIN_KEY, objMsg);
    }
  }, [objMsg]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (current === 0 && contractFormData.editForm) getPreview(Schema.rentContract.preview(contractFormData));
  }, [current]);

  useEffect(() => {
    if (pathname.includes('/contracts/admin/edit_contract/')) {
      setSiderVisible(true);
    } else {
      setSiderVisible(false);
    }
  }, [pathname]);

  const formContent = (data) => {
    if (activeStep < 3) {
      updateForm({
        ...contractFormData,
        ...data,
        ...images,
      });
    }
    if (activeStep < steps.length - 1) {
      handleNext();
    } else {
      setCurrent(0);
    }
  };

  const submitContract = async () => {
    setLoaderSpinning(true);
    sendContract(params, await Schema.rentContract.edit(contractFormData));
  };

  const handleNext = () => {
    setActiveStep(activeStep + 1);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const steps = [
    {
      title: 'Información firmantes',
      content: <SignersStep form={form} />,
    },
    {
      title: 'Inmueble y condiciones',
      content: <PropertyStep />,
    },
    {
      title: 'Contrato y cuenta',
      content: <AccountStep form={form} />,
    }
  ];

  return (
    <>
      {loaderSpinning
        ? <Spin className="spin-centered" tip="Cargando..."></Spin>
        : <>
          <Content>
            {siderVisible &&
              <Header style={{ position: 'fixed', zIndex: 10, width: '100%' }}>
                <PageHeader
                  className="site-page-header"
                  onBack={() => history.push(`/contracts/contract_detail/${params}`)}
                  subTitle="Volver al detalle"
                  style={{ padding: 0 }}
                />
              </Header>
            }
            {current === 0 &&
              <React.Fragment>
                <div style={{ width: '60%', margin: 'auto', marginBottom: '100px' }}>
                  <ShowPdf pdf={contractPdf} />
                </div>
                <div className="buttons-container justify-content-end bg-white">
                  <Button
                    type="default"
                    size="large"
                    className="mr-2"
                    onClick={() => {
                      setCurrent(1);
                      setActiveStep(0);
                    }}
                  >
                    Editar
                  </Button>
                  <Button type="primary" size="large" onClick={submitContract} >
                    Enviar
                  </Button>
                </div>
              </React.Fragment>
            }
            {current === 1 &&
              <>
                <CreateContractHeader steps={steps} activeStep={activeStep} />
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={formContent}
                  onFinishFailed={alertError}
                  autoComplete="on"
                  scrollToFirstError
                >
                  <Content className="ant-layout-content-admin">
                    <div className="steps-content">{steps[activeStep].content}</div>
                  </Content>
                  <div className="buttons-container justify-content-center">
                    <Space>
                      <PreviewModal />
                      <Button size="large"
                        onClick={() => {
                          activeStep > 0 ? handleBack() : setCurrent(0);
                        }}
                      >
                        Volver
                      </Button>
                      <Button type="primary" htmlType="submit" size="large">
                        Continuar
                      </Button>
                    </Space>
                  </div>
                </Form>
              </>
            }
          </Content>
        </>
      }
    </>
  );
};

EditContract.propTypes = {
  getContractDataForm: PropTypes.func.isRequired,
  contractFormData: PropTypes.object.isRequired,
  updateForm: PropTypes.func.isRequired,
  sendContract: PropTypes.func.isRequired,
  isCreated: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  resetStatus: PropTypes.func.isRequired,
  images: PropTypes.object.isRequired,
  contractPdf: PropTypes.string.isRequired,
  getPDF: PropTypes.func.isRequired,
  getPreview: PropTypes.func.isRequired,
};

const data = (state) => ({
  contractFormData: state.contract.contractFormData,
  isCreated: state.contract.isCreated,
  isLoaded: state.contract.isLoaded,
  images: state.contract.images,
  contractPdf: state.contract.contractPdf,
});

const action = (dispatch) => ({
  getPDF: (id) => dispatch({ type: GET_CONTRACT_PDF, payload: { id, resource: RESOURCE.GET_CONTRACT_PDF } }),
  updateForm: (data) => dispatch({ type: CONTRACT_FORM_DATA, payload: { ...data } }),
  getContractDataForm: (id) => dispatch({ type: GET_CONTRACT_DATA_FORM, payload: { id, resource: RESOURCE.GET_CONTRACT_DATA_FORM } }),
  sendContract: (id, doc) => dispatch({ type: ADMIN_UPDATE_CONTRACT_FORM_DATA, payload: { id, doc, resource: RESOURCE.ADMIN_UPDATE_CONTRACT_FORM_DATA } }),
  resetStatus: () => dispatch({ type: CONTRACT_IS_CREATED, payload: false }),
  getPreview: payload => dispatch({ type: GET_PREVIEW_PDF, payload: { payload, resource: RESOURCE.GET_PREVIEW_PDF } }),
});

export default connect(data, action)(EditContract);